var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filenames"},[_vm._v("\n  FILENAMES - "+_vm._s(_vm.gameName.game)+"\n  "),_c('div',_vm._l((_vm.overlayData),function(filename){return _c('li',[_vm._v("\n      "+_vm._s(filename.name)+": $"+_vm._s(filename.amount)+"\n    ")])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-082bfb0a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Filenames.vue
// module id = null
// module chunks = 